<template>
  <g>
    <circle
      r="1.25"
      :cx="x"
      :cy="y"
      :fill="strokeColor"
    />
    <circle
      r="1.25"
      :cx="horizontal ? x + 6 : x"
      :cy="horizontal ? y : y + 6"
      :fill="strokeColor"
    />
    <circle
      r="1.25"
      :cx="horizontal ? x + 12 : x"
      :cy="horizontal ? y : y + 12"
      :fill="strokeColor"
    />
  </g>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  name: 'FloorplanShapeOverflow',
  props: {
    x: { type: Number, required: true },
    y: { type: Number, required: true },
    horizontal: { type: Boolean, required: false, default: false },
    strokeColor: { type: String, required: true },
  },
  data() {
    return { };
  },
});

</script>
